<template>
  <ButtonElement :block="block"
                 :class="setWidthClass"
                 :disabled="disabled"
                 :href="href"
                 :icon-name="iconName"
                 :icon-size="iconSize"
                 :size="size"
                 :tabindex="tabindex"
                 :title="title"
                 :to="to"
                 :type="type"
                 :variant="variant"
                 text=""
                 @click="$emit('click', $event)">
  </ButtonElement>
</template>

<script>
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import ButtonElement from './ButtonElement.vue';

  export default {
    name: 'ButtonIconOnly',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
    },
    components: {
      ButtonElement,
    },
    props: {
      block: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      href: {
        type: String,
        default: null,
      },
      iconSize: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      iconName: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      tabindex: {
        type: String,
      },
      title: {
        type: String,
        required: true,
      },
      to: {
        type: String,
        default: null,
      },
      type: {
        type: String,
        default: 'button',
      },
      variant: {
        type: String,
        default: BootstrapVariant.PRIMARY,
      },
    },
    emits: ['click'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    computed: {
      setWidthClass() {
        if (this.size === BootstrapVariant.SMALL) {
          return 'btn-sm-icon-only';
        }
        return '';
      },
    },
  };
</script>
